import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { PenSVG } from 'components/common/SVGElements'
import Link from 'components/common/A'
import NowrapDiv from 'components/common/NowrapDiv'

const VenderLink = ({ vender, ...props }) => {
  if (!vender) {
    return null
  }
  return (
    <Link href={`/vender/${vender?.urlId}`} $color="text.minus2">
      <Box display="flex" alignItems="center" flexWrap="nowrap">
        <PenSVG $color="text.disabled" {...props} />
        <Typography
          ml={1.5}
          color="text.disabled"
          sx={{
            typography: { xs: 'bodyXs', md: 'bodySmall' },
          }}
        >
          <NowrapDiv>{vender?.shortname}</NowrapDiv>
        </Typography>
      </Box>
    </Link>
  )
}

export default VenderLink
